/**
 * THI-196 task 8 (E4 frame 5, handoff 21 §3): the Tiến độ tab's read-only
 * strip always shows `max` real thumbnails, and adds a separate "+n" chip
 * slot ONLY when there are more — `max` thumbnails then the chip, never
 * `max` MINUS one thumbnail bumped out to make room for it (that's the
 * parent page's and the editable strip's own, different rule; this one is
 * D3's own, per the mock's frame 5: 6 photos render as 4 thumbnails + "+2",
 * not 3 + "+3").
 */
export function splitPhotoStrip<T>(items: T[], max: number): { shown: T[]; overflow: number } {
  const overflow = items.length > max ? items.length - max : 0;
  return { shown: items.slice(0, max), overflow };
}
